import styled from 'styled-components';

const Title = styled.div`
  font-size: 30px;
  font-weight: bold;
  letter-spacing: -0.1px;
  color: rgb(54, 61, 74);
`;

export default Title;
